/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import {
  HideToastEvent,
  MessageEventPayload,
  MessageToastEvent,
  ToastEvent,
} from '@abyss/web/hooks/useToast';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { ResultsStatus } from '@src/common/types';

export const downloadGraphToast = downloadGraphToastFn();

function downloadGraphToastFn() {
  const autoCloseTime = 4000;
  let toast = getDefaultToast();

  return {
    showImageToast: () => toast.show(getImageToastProps()),
    showImageErrorToast: () => toast.show(getImageToastErrorProps()),
    hideImageToast: () => toast.hide(getImageToastProps().id!),
    showCsvToast,
    setToast: (_toast: typeof toast) => {
      toast = _toast;
    },
  };

  function showCsvToast(resultStatus: ResultsStatus) {
    const props = getCsvToastProps();
    if (resultStatus === ResultsStatus.error) {
      props.variant = 'error';
      props.title = 'Error';
      props.message =
        'There was a problem downloading the data. Please try again later.';
      props.icon = undefined;
      props.autoClose = false;
    }
    toast.show(props);
  }

  function getDefaultToast() {
    const defaultToast: {
      show: MessageToastEvent;
      update: MessageToastEvent;
      hide: HideToastEvent;
      cleanQueue: ToastEvent;
      clean: ToastEvent;
    } = {
      show: () => {},
      hide: () => {},
      clean: () => {},
      cleanQueue: () => {},
      update: () => {},
    };
    return defaultToast;
  }

  function getImageToastProps(): MessageEventPayload {
    return {
      id: 'image-export-toast',
      withCloseButton: true,
      title: 'Preparing image...',
      message: ``,
      icon: <IconSymbol icon="info" />,
      variant: 'info',
      autoClose: autoCloseTime,
    };
  }

  function getImageToastErrorProps(): MessageEventPayload {
    return {
      ...getImageToastProps(),
      title: 'Failed to download image',
      icon: undefined,
      variant: 'error',
    };
  }

  function getCsvToastProps(): MessageEventPayload {
    return {
      ...getImageToastProps(),
      id: 'csv-export-toast',
      title: 'Preparing file...',
    };
  }
}
